import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20interior%20with%20dramatic%20stage%20lighting%2C%20red%20velvet%20curtains%2C%20golden%20spotlights%2C%20atmospheric%20fog%2C%20luxurious%20movie%20theater%20aesthetic%2C%20warm%20and%20rich%20color%20tones%2C%20professional%20cinematography&width=1800&height=900&seq=yuhuo-hero-bg&orientation=landscape"
        alt="欲火视频 - 热门影视资源在线观看平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 mb-6">
            <i className="ri-fire-line text-primary-400"></i>
            <span className="text-sm text-primary-200 font-medium">每日更新 · 海量资源</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-4 leading-tight">
            欲火视频
            <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-2 text-background-200/90">
              热门影视资源在线观看平台
            </span>
          </h1>

          <p className="text-base md:text-lg text-background-200/80 mb-8 max-w-xl mx-auto leading-relaxed">
            欲火视频提供海量高清影视资源，涵盖热门剧集、电影大片、动漫综艺及短视频内容，支持多终端流畅播放，每日更新最新内容，让您随时随地畅享极致视听体验。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/recommended"
              className="px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-300 shadow-lg shadow-primary-500/30 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>
              立即观看
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white font-medium text-sm hover:bg-white/25 transition-all duration-300 border border-white/20 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line mr-2"></i>
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">10万+</div>
              <div className="text-xs text-background-300 mt-1">影视资源</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">5000万+</div>
              <div className="text-xs text-background-300 mt-1">活跃用户</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">99.9%</div>
              <div className="text-xs text-background-300 mt-1">服务可用率</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}